var PhxCheckout = (function (PhxCheckout) {
  //Import modules only for jest.
  if(typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
        const messenger = require('./messenger');
        Object.assign(PhxCheckout, messenger)
    }
    PhxCheckout.logger = function logger() {
        // Copied portions from eventRecorderSvc.js (Phx-web)
        // Fake up newrelic endpoints if not available, as in
        // Jasmine test environment... or if we haven't included
        // newrelic scripts.

        //Checks if console is available.
        function _hasConsole () {
            return (typeof console !== 'undefined' && typeof console.log !== 'undefined');
        }

        //_logDefault(): default / fallback (console) logger if NR is not enabled.
        function _logDefault(name, value) {
            if (_hasConsole())
                console.log('IFRAME EVENT [Name: ' + name + '] [ Value: ' + JSON.stringify(value) + ']');
        }

        //_sendActionToServer(): semaphore for logging messages back to the main window.
        function _sendActionToServer(actionType, name, values) {
            payload = {
                action: actionType,
                data: [name, values]
            };

            PhxCheckout.messenger.postMessageToParent(payload);
        }

        //_logEventToServer(): if NR is enabled, it logs data to NR, else: local console.
        function _logEventToServer(name, values) {
            _sendActionToServer('NRADDPAGEACTION', name, values);
        }

        //_logBreadCrumbEventToServer(): separate channel for logging events + attributes.
        //Note: the reason why we have this separate method is that:
        //1. The types of actions we will log are different.
        //2. The way the attributes are logged / payload is different.
        function _logBreadCrumbEventToServer(bcActionName, values) {
            _sendActionToServer('NRBREADCRUMBACTION', bcActionName, values);
        }

        return {
            logEventToServer: _logEventToServer,
            logBreadCrumbEventToServer: _logBreadCrumbEventToServer,
            logDefault: _logDefault,
            hasConsole: _hasConsole
        }
    }();

    return PhxCheckout;

}(PhxCheckout || {}));

if(typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
    module.exports = PhxCheckout //export it as module only for jest.
}

